import React from 'react';
import 'bootstrap-icons/font/bootstrap-icons.css';

export default function Sobre() {
    return (
        <>
            <section id="sobre">
                <div className="container">
                    <div className="margin-bottom-20 margin-top-30">
                        <div className="row">
                            <div className="col-md-12">
                                <h1 className="titulo">Sobre</h1>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12 text-center">
                                <p className="p-md">
                                    A <span>Mocidade Espírita</span> é um curso que proporciona a vivência do Espiritismo para jovens.
                                    Carinhosamente chamada de <span>Escola do Coração</span>, ela busca criar um ambiente de “ameaça zero”,
                                    sem preconceitos e julgamentos, onde todos possam se <span>sentir acolhidos</span> e fortalecidos num grupo
                                    verdadeiramente <span>fraterno e amoroso</span>.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="section-lines">
                <div className="container text-center">
                    <div className="row margin-bottom-20">
                        <div className="col-md-12">
                            <h1 className="titulo">Ciclos de Aulas</h1>
                        </div>
                        <div className="col-md-12 margin-bottom-20 text-center">
                            <p className="p-md">
                                O programa do curso é formado por <span>Ciclos de Aulas</span>. Juntos nós iremos nos aprofundar no estudo dos seguintes temas.
                                &nbsp;<span role="img" aria-label="">📚💓</span>
                            </p>
                        </div>
                    </div>
                    <div className="row margin-bottom-20">
                        <div className="col-xs-12 col-sm-12 col-md-3">
                            <div className="card">
                                <div className="card-body text-center">
                                    <i className="bi bi-people icon"></i>
                                    <h5 className="card-title">Amizade</h5>
                                    <p className="card-text margin-top-20">
                                        Propiciar um momento em que os jovens se conheçam e se integrem.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-3">
                            <div className="card">
                                <div className="card-body text-center">
                                    <i className="bi bi-heart icon"></i>
                                    <h5 className="card-title">Coração</h5>
                                    <p className="card-text margin-top-20">
                                        Trabalhar os sentimentos.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-3">
                            <div className="card">
                                <div className="card-body text-center">
                                    <i className="bi bi-chat-text icon"></i>
                                    <h5 className="card-title">Fé Raciocinada</h5>
                                    <p className="card-text margin-top-20">
                                        Dar subsídios aos jovens sobre a importância do ato de pensar, desde os fundamentos da Doutrina Espírita até os pensamentos e atitudes de Kardec e de Espíritas brasileiros.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-3">
                            <div className="card">
                                <div className="card-body text-center">
                                    <i className="bi bi-globe icon"></i>
                                    <h5 className="card-title">O Cristão no Mundo</h5>
                                    <p className="card-text margin-top-20">
                                        Aborda reflexões sobre a moral em diversos aspectos da vida da sociedade moderna, desde tecnologia e ciência, poder e política até artes.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}